
import { useMutation, useQuery } from "@tanstack/react-query";
import { sprintService } from "services/sprintService";
import { FormSprintStore, FormSprintUpdate, IdForm } from "types";

export function useSprint() {
    const getDetail = async (projectId, id) => {
        if (!projectId) return;

        const data = await sprintService.show(projectId, id);
        return data;
    };

    const fetchDataDetail = (projectId, id) => {
        return useQuery({
            queryKey: ['sprintDetail', projectId, id],
            enabled: !!projectId,
            queryFn: () => getDetail(projectId, id),
            staleTime: 1000 * 60 * 3,
        });
    }

    const getList = async (projectId, page = 1) => {
        const data = await sprintService.onGetList(projectId, page);
        return data;
    };

    const fetchData = (projectId, currentPage, isFetch = 1) => {
        return useQuery({
            queryKey: ['sprints', projectId, currentPage, isFetch],
            queryFn: () => getList(projectId, currentPage),
            enabled: !!projectId,
            staleTime: 1000 * 60 * 3,
            select: (data) => ({
                data: data?.data,
                totalPage: data?.totalPage ?? 1,
            }),
        });
    }

    const createSprint = useMutation({
        mutationFn: (payload: FormSprintStore) => sprintService.store(payload),
        onSuccess: async (res) => res,
        onError: (err) => {
            console.error("createSprint failed", err);
        },
    });

    const updateSprint = useMutation({
        mutationFn: (formData: FormSprintUpdate) => sprintService.update(formData),
        onSuccess: async (res) => res,
        onError: (err) => {
            console.error("updateSprint failed", err);
        },
    });

    const delSprint = useMutation({
        mutationFn: (formData: IdForm) => sprintService.destroy(formData),
        onSuccess: async (res) => res,
        onError: (err) => {
            console.error("delSprint failed", err);
        },
    });

    return { fetchData, fetchDataDetail, getList, createSprint, updateSprint, delSprint }
}
